import { Injectable } from "@angular/core";
import { IID_GR_TASKS } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDGrTasksStore } from "./iidGRTasks.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.GR_TASKS)
export class IIDGrTasksQuery extends AbstractInterfaceDataQuery<IID_GR_TASKS> {

  constructor(protected store: IIDGrTasksStore) {
    super(store);
  }

}
